import { Component, OnInit } from '@angular/core';
import { AppReleaseService } from '../../services/app-release.service';
import { Router } from '@angular/router';
import { ConfirmationService, DataTable, Message, SelectItem } from 'primeng/primeng';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { AppRelease, Platform } from '../../models/inModels/app-release.model';

@Component({
  selector: 'app-app-release',
  templateUrl: './app-release.component.html'
})
export class AppReleaseComponent implements OnInit {
    rows: SelectItem[];
    selectedRows: number;
    filteredRecords: number;
    rowEvent: LazyLoadEvent;
    loading: boolean;
    totalRecords: number;
    error: Message[];
    selectedApp: AppRelease;
    items: AppRelease[];
    constructor(
            private service: AppReleaseService,
            private router: Router,
            private confirmationService: ConfirmationService
      ){
        this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
      }

    ngOnInit() {
        // Initialization logic can go here
    }

    changeRows(event): void {
		this.load(this.rowEvent);
	}

    load(event: LazyLoadEvent): void {
        this.loading = true;
        event.rows = this.selectedRows;
        this.rowEvent = event;
        this.service.search(event).then(
        dataPager => {
        this.items = dataPager.Data;
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
        console.log(this.items);
            },
            error => {
                this.loading = false;
                this.items = [];
                this.totalRecords = 0;
                this.filteredRecords = 0;
                this.error = [];
                this.error.push({ severity: 'error', summary: 'Error', detail: error });
            }
        );
    }

    reset(dt: DataTable, gb: HTMLInputElement) {
        gb.value = '';
        dt.reset();
    }
    
    edit(item: AppRelease) {
        this.router.navigate(['app-releases/edit', item.Id]);
    }

    delete(event: AppRelease) {
            console.log(event);
           this.confirmationService.confirm({
            message: `
            <div>
                Are you sure you want to delete 
                <strong class="text-danger">${Platform[event.Platform]}</strong> 
                version 
                <span class="fw-bold text-primary">${event.VersionNumber}</span> 
                file 
                <span class="fw-bold text-warning">${event.FileName}</span>?
            </div>`,
            header: 'Confirmation',
            icon: 'fa fa-trash-o',
            accept: () => {
                this.loading = true;
                this.service.delete(event.Id).then(
                    result => {
                        this.loading = false;
                        this.load(this.rowEvent);
                    },
                    error => {
                        this.loading = false;
                        this.error = [];
                        this.error.push({ severity: 'error', summary: 'Error', detail: error });
                    });
            }
        });

      }
}


    



// WEBPACK FOOTER //
// ./src/app/components/app-release/app-release.component.ts